module.exports = __webpack_public_path__ + "0a799148a50bb02c6f380eabd8d97559.svg";